import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import RouterComponent from './RouterComponent';
import Lenis from 'lenis';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
      prevent: (node) => {
        let current = node;
        while (current && current !== document.body && current !== document.documentElement) {
          if (current.hasAttribute('data-lenis-prevent')) return true;
          const style = window.getComputedStyle(current);
          const overflowY = style.overflowY;
          if (overflowY === 'auto' || overflowY === 'scroll') {
            if (current.scrollHeight > current.clientHeight) {
              return true;
            }
          }
          current = current.parentElement;
        }
        return false;
      }
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter >
      <RouterComponent />
    </BrowserRouter>
  );
}

export default App;
